import { render } from "./PerformanceReport.vue?vue&type=template&id=e89f3dcc&ts=true"
import script from "./PerformanceReport.vue?vue&type=script&lang=ts"
export * from "./PerformanceReport.vue?vue&type=script&lang=ts"

import exportComponent from "/home/muhammadibrahim/Myserver/Medix_v4_envato/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__